import React, { lazy, Suspense, useEffect, useState } from 'react'

const LazyDeviceFingerPrintImpl = lazy(() => import('./DeviceFingerPrint'))

interface Props {
  setSid?: (value: null | string) => void
  triggerId?: string
}

const DeviceFingerPrint: React.FC<Props> = ({ setSid, triggerId }) => {
  const [enabled, setEnabled] = useState(false)

  useEffect(() => {
    if (enabled) return
    const onPointerDown = (event: Event) => {
      const target = event.target as Element | null
      if (triggerId && target?.closest(`#${triggerId}`)) {
        setEnabled(true)
      }
    }
    document.addEventListener('pointerdown', onPointerDown, { capture: true, passive: true })
    return () => document.removeEventListener('pointerdown', onPointerDown, true)
  }, [])

  if (!enabled && triggerId) return null

  return (
    <Suspense fallback={null}>
      <LazyDeviceFingerPrintImpl setSid={setSid} />
    </Suspense>
  )
}

export default DeviceFingerPrint
